module.exports = __webpack_public_path__ + "static/media/sucua_portal_fondo.8ed933e6.png";